export const themes = {
  default: {
    thRoot: 'flex flex-col sm:flex-row sm:items-center',
    thLabel: 'flex flex-col sm:flex-row sm:flex-1 items-center sm:rtl:mr-5 text-center',
    thLabelIconSize: '1.25rem',
    thText: 'font-bold mt-2 sm:mt-0 sm:rtl:ml-2',
    thList: 'reset-list flex flex-col sm:flex-row flex-shrink-0 flex-start',
    thListItem: 'flex justify-center mt-4 sm:mt-0 sm:px-3',
    thListItemIcon: 'flex-shrink-0 rtl:mr-1',
    thLink:
      'reset-anchor inline-flex flex-row-reverse font-bold items-center text-blue hover:text-blue-active focus:text-blue-active text-sm transition-color underline uppercase',
  },
  lite: {
    thRoot: 'flex flex-col sm:flex-row sm:items-center',
    thLabel: 'flex flex-row items-center sm:rtl:mr-5',
    thLabelIconSize: '1rem',
    thText: 'font-bold mt-2 sm:mt-0 rtl:ml-2',
    thList: 'reset-list flex flex-col sm:flex-row flex-shrink-0 sm:-mx-1',
    thListItem: 'flex items-center sm:mt-0 sm:px-1 text-blue w-full sm:w-auto',
    thListItemIcon: 'flex-shrink-0 rtl:mr-1',
    thListItemIconSize: '1.3rem',
    thLink:
      'reset-anchor inline-block font-bold items-center text-blue hover:text-blue-active focus:text-blue-active text-md transition-color underline w-full',
  },
};
